import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LicensePageMeta = _resolveComponent("LicensePageMeta")!

  return (_openBlock(), _createBlock(_component_LicensePageMeta, { items: _ctx.items }, null, 8, ["items"]))
}